const Theme = {
  header_background_color: '#0d53bc',
  logo_image_url: 'allaround.png',
  logo_height: 85,
  token_url: 'allaround.png',
  number_hidden: true,

  button_color: '#0d53bc',
  button_radius: 12,
  button_half_border_color: '#0d53bc',

  text_font: `'Raleway', sans-serif`,
  text_color: '#484848',
  text_weight: 500,
  title_font: `'Raleway', sans-serif`,
}

export default Theme
